(function () {
    'use strict';

    angular
        .module('sodCommon')
        .factory('action-disable-button', actionFunc);

    function actionFunc(ButtonRegistry, lodash, $q) {
        return function(options) {
            return $q.when(run());

            function run() {
                if (lodash.has(options, 'button_names')) {
                    let button_names = options.button_names;
                    if (!(button_names instanceof Array)) {
                        if (button_names === null || button_names.length === 0) {
                            button_names = [];
                        } else {
                            button_names = [button_names];
                        }
                    }

                    if (lodash.isEmpty(button_names)) {
                        ButtonRegistry.disableAllButtons();
                        if (lodash.get(options,'set_loading', false) == true) {
                            ButtonRegistry.setAllLoading();
                        }
                    }

                    if (!lodash.isEmpty(button_names)) {
                        // for (const name of button_names) {
                        ButtonRegistry.disableButtons(button_names);
                        // }
                        if (lodash.get(options,'set_loading', false) == true) {
                            ButtonRegistry.setLoading(button_names);
                        }
                    }
                }
                if (!lodash.has(options, 'button_names')) {
                    ButtonRegistry.disableAllButtons();
                    if (lodash.get(options,'set_loading', false) == true) {
                        ButtonRegistry.setAllLoading();
                    }
                }
                return true;
            }
        };
    }
})();